import React from "react";
import TitleBar from "../../partials/content/TitleBar";
import AddSiteUserAdvertiser from "./AddSiteUserAdvertiser";
import InfoSiteUserAdvertiser from "./InfoSiteUserAdvertiser";
import StateSiteUserAdvertiser from "./StateSiteUserAdvertiser";
import helpersNumber from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import ButtonDisable from "../../partials/other/ButtonDisable";

export default function AllSiteUserAdvertiser() {
  const allSiteUserAdvertiser = [
    {
      id: 1,
      site_url: "https://test1.ir",
      hashIDScript: "vdJpbMNy8w_ajGOgYpLYm_xBdEq0pRPL",
      state: "تایید شده",
      message: "",
      created_at: "2022-07-28 11:04:23",
    },
    {
      id: 2,
      site_url: "https://test2.ir",
      hashIDScript: "vdJpbMNy8w_J9LNQPO81n_xBdEq0pRPL",
      state: "رد شده",
      message: "اسکریپت در سایت شما موجود نیست.",
      created_at: "2022-07-28 09:46:17",
    },
    {
      id: 3,
      site_url: "https://test3.ir",
      hashIDScript: "vdJpbMNy8w_xBdEq0pRPL_xBdEq0pRPL",
      state: "در حال انتظار",
      message: "",
      created_at: "2022-07-12 14:11:55",
    },
  ];

  const generateAllSiteUserAdvertiser = () => {
    return (
      <>
        <AddSiteUserAdvertiser />
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره</td>
                <td>آدرس سایت</td>
                <td>وضعیت</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allSiteUserAdvertiser.map((siteUserAdvertiser, index) => {
                let classNameBadgeType = "";
                switch (siteUserAdvertiser.state) {
                  case StateSiteUserAdvertiser.statusSiteUserAdvertiser.PENDING:
                    classNameBadgeType = "warning";
                    break;
                  case StateSiteUserAdvertiser.statusSiteUserAdvertiser.CONFIRM:
                    classNameBadgeType = "success";
                    break;
                  case StateSiteUserAdvertiser.statusSiteUserAdvertiser.REJECT:
                    classNameBadgeType = "danger";
                    break;
                }

                return (
                  <tr key={siteUserAdvertiser.id}>
                    <td>{helpersNumber.toPersianNum(index + 1)}</td>
                    <td>{helpersNumber.toPersianNum(siteUserAdvertiser.id)}</td>
                    <td className="text-left">
                      <a href={siteUserAdvertiser.site_url} target="_blank">
                        {siteUserAdvertiser.site_url}
                      </a>
                    </td>
                    <td>
                      <span className={`badge  badge-${classNameBadgeType}`}>
                        {siteUserAdvertiser.state}
                      </span>
                    </td>
                    <td dir="ltr">
                      {helpersNumber.toPersianNum(
                        helpersTime.convertGregorianToJalali(
                          siteUserAdvertiser.created_at.split(" ")[0]
                        ) +
                          " " +
                          siteUserAdvertiser.created_at.split(" ")[1]
                      )}
                    </td>
                    <td>
                      <InfoSiteUserAdvertiser
                        siteUserAdvertiser={siteUserAdvertiser}
                      />
                      <span className="pr-2">
                        <ButtonDisable
                          buttonTagHtml={
                            <span className="btn btn-danger opacity-50">
                              حذف
                            </span>
                          }
                        ></ButtonDisable>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <div className="container-fluid pt-3 container-all-site-user-advertiser">
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-lg-12 p-0">
          <TitleBar title="سایت های تبلیغ دهنده" />

          <section className="content pt-5">
            <div className="card">
              <div className="card-body">{generateAllSiteUserAdvertiser()}</div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
